import { Component, OnInit, forwardRef } from '@angular/core';
import { 
    IonGrid, IonRow, IonCol, IonSpinner
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvCircleComponent } from '@marv/components';
import { PermanentOperationItemComponent, PermanentOperationItem } from '@app/components';
import { PermanentOperation } from '@app/models';
import { OperationService } from '@app/services';

@Component({
    selector: 'app-my-permanent-operation',
    templateUrl: './my-permanent.component.html',
    styleUrls: ['./my-permanent.component.scss'],
    imports: [
        IonGrid, IonRow, IonCol, IonSpinner, TranslatePipe, 
        MarvCircleComponent, forwardRef(() => PermanentOperationItemComponent)
    ]
})
export class MyPermanentOperationComponent  implements OnInit {

    isFetching: boolean = false;
    permanentsOperationsItems: Array<PermanentOperationItem> = [];

    constructor(
        private operationService: OperationService
    ) { }

    async ngOnInit() {
        let permanentsOperationsItems: Array<PermanentOperationItem> = [];
        let permanentsOperations = await this.operationService.loadPermanentsOperations();
        if(permanentsOperations){
            for(let o of permanentsOperations){
                permanentsOperationsItems.push(PermanentOperationItem.FromPermanentOperation(o));
            }
        }
        this.permanentsOperationsItems = permanentsOperationsItems;
    }

}
